<lib-auth-layout>
  <div *transloco="let t">
    <article class="auth-card auth-card--login">
      <header class="auth-card__header">
        <img
          src="/assets/logo.png"
          [alt]="t('brand.logo_alt')"
          class="auth-card__logo"
        />
        <h2>{{ t('login.header') }}</h2>
      </header>

      <div class="auth-card__body">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
          @if (errorMessage()) {
          <div class="alert alert-danger" role="alert">
            {{ errorMessage() }}
          </div>
          }

          <div class="auth-card__form-shell">
            <div class="auth-input-wrap">
              <div class="auth-input-row">
                <span class="auth-input-row__icon">
                  <i class="far fa-envelope"></i>
                </span>
                <input
                  id="email"
                  type="email"
                  class="form-control auth-input"
                  [class.is-invalid]="email?.invalid && email?.touched"
                  formControlName="email"
                  placeholder="{{ t('login.email_label') }}"
                  autocomplete="email"
                />
                <span class="auth-input-row__suffix">
                  <i class="far fa-user"></i>
                </span>
              </div>
              @if (email?.invalid && email?.touched) {
              <div class="invalid-feedback d-block">
                @if (email?.errors?.['required']) {
                {{ t('validation.email_required') }}
                } @if (email?.errors?.['email']) {
                {{ t('validation.email_invalid') }}
                }
              </div>
              }
            </div>

            <div class="auth-input-wrap">
              <div class="auth-input-row auth-input-row--password">
                <span class="auth-input-row__icon">
                  <i class="fas fa-lock"></i>
                </span>
                <input
                  id="password"
                  [type]="showPassword() ? 'text' : 'password'"
                  class="form-control auth-input"
                  [class.is-invalid]="password?.invalid && password?.touched"
                  formControlName="password"
                  placeholder="{{ t('login.password_label') }}"
                  autocomplete="current-password"
                />
                <button
                  type="button"
                  class="auth-input-row__action"
                  (click)="togglePasswordVisibility()"
                  [attr.aria-label]="t('login.password_label')"
                >
                  <i
                    [class]="showPassword() ? 'fas fa-eye-slash' : 'fas fa-eye'"
                  ></i>
                </button>
              </div>
              @if (password?.invalid && password?.touched) {
              <div class="invalid-feedback d-block">
                @if (password?.errors?.['required']) {
                {{ t('validation.password_required') }}
                }
              </div>
              }
              <div class="auth-forgot-row">
                <a class="auth-forgot-link" routerLink="/auth/reset-password">
                  {{ t('login.forgot_password') }}
                </a>
              </div>
            </div>

            <div class="auth-remember-row">
              <div class="form-check auth-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="rememberMe"
                  formControlName="rememberMe"
                />
                <label class="form-check-label" for="rememberMe">
                  {{ t('login.remember_me') }}
                </label>
              </div>
            </div>

            <button
              type="submit"
              class="btn btn-primary btn-login auth-submit w-100"
              [disabled]="isLoading()"
            >
              @if (isLoading()) {
              <span
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              {{ t('login.logging_in') }}
              } @else {
              <i class="fas fa-sign-in-alt me-2"></i>
              {{ t('login.button') }}
              }
            </button>

            <div class="divider">
              <span class="divider-text">{{ t('common.or') }}</span>
            </div>

            <div class="social-login">
              <button
                type="button"
                class="social-btn google"
                [attr.aria-label]="t('login.social_google_aria_label')"
                (click)="onSocialLogin('Google')"
              >
                <i class="fab fa-google"></i>
              </button>
              <button
                type="button"
                class="social-btn facebook"
                [attr.aria-label]="t('login.social_facebook_aria_label')"
                (click)="onSocialLogin('Facebook')"
              >
                <i class="fab fa-facebook-f"></i>
              </button>
              <button
                type="button"
                class="social-btn apple"
                [attr.aria-label]="t('login.social_apple_aria_label')"
                (click)="onSocialLogin('Apple')"
              >
                <i class="fab fa-apple"></i>
              </button>
            </div>

            <p class="auth-alt-action text-center">
              {{ t('login.register_prompt') }}
              <a routerLink="/auth/register">{{ t('login.register_link') }}</a>
            </p>
          </div>
        </form>
      </div>
    </article>
  </div>
</lib-auth-layout>
